"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LetterModalBody = LetterModalBody;
const react_1 = __importStar(require("react"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const LettersController_1 = require("../LettersController");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const InlineCreateDrawer_1 = require("../../../View/Modals/InlineCreateDrawer");
const CaseInlineCreateBody_1 = require("../../../TasksGlobal/Modals/Case/CaseInlineCreateBody");
const CaseModalBody_1 = require("../../../TasksGlobal/Modals/Case/CaseModalBody");
const CaseValidationSchema_1 = require("../../../TasksGlobal/Modals/Case/CaseValidationSchema");
const CaseModalButtons_1 = require("../../../TasksGlobal/Modals/Case/CaseModalButtons");
function LetterModalBody({ isEditing, initialData, getConfidenceClass = () => '', fileInputRef }) {
    const { register, reset, setValue, watch, formState: { dirtyFields, errors, isValid }, trigger, } = (0, FormContext_1.useFormContext)();
    const _offer = watch("_offer");
    const creationDate = watch("creationDate");
    const registrationDate = watch("registrationDate");
    // Panel inline-tworzenia/edycji Sprawy (Offcanvas) + token wymuszający odświeżenie opcji
    // selektora ze źródła prawdy (casesRepository.items). Analogicznie do pism do kontraktów.
    const [showCreateCase, setShowCreateCase] = (0, react_1.useState)(false);
    const [showEditCase, setShowEditCase] = (0, react_1.useState)(false);
    const [caseToEdit, setCaseToEdit] = (0, react_1.useState)(undefined);
    const [caseOptionsRefreshToken, setCaseOptionsRefreshToken] = (0, react_1.useState)(0);
    // Po utworzeniu sprawy w panelu: addNewItem dopisał ją już do casesRepository.items
    // (źródło prawdy). Auto-zaznaczamy ją w `_cases` i podbijamy token, by selektor
    // przebudował opcje z repository.items.
    function handleCaseCreated(newCase) {
        const created = LettersController_1.casesRepository.items.find((item) => item.id === newCase.id) ?? newCase;
        const current = watch("_cases") ?? [];
        const alreadySelected = current.some((item) => item.id === created.id);
        const nextCases = alreadySelected ? current : [...current, created];
        setValue("_cases", nextCases, { shouldValidate: true });
        setCaseOptionsRefreshToken((token) => token + 1);
    }
    // Po edycji sprawy: editItem zaktualizował casesRepository.items (źródło prawdy).
    function handleCaseEdited(editedCase) {
        const updated = LettersController_1.casesRepository.items.find((item) => item.id === editedCase.id) ?? editedCase;
        const current = watch("_cases") ?? [];
        const nextCases = current.map((item) => (item.id === updated.id ? updated : item));
        setValue("_cases", nextCases, { shouldValidate: true });
        setCaseOptionsRefreshToken((token) => token + 1);
    }
    (0, react_1.useEffect)(() => {
        let defaultEditor;
        if (!isEditing) {
            const currentUser = MainSetupReact_1.default.currentUser;
            if (currentUser && MainSetupReact_1.default.personsEnviRepository.items.length > 0) {
                defaultEditor = MainSetupReact_1.default.personsEnviRepository.items.find((person) => person.email === currentUser.systemEmail);
            }
        }
        const resetData = {
            _offer: initialData?._offer,
            _cases: initialData?._cases || [],
            description: initialData?.description || "",
            creationDate: initialData?.creationDate || new Date().toISOString().slice(0, 10),
            registrationDate: initialData?.registrationDate || new Date().toISOString().slice(0, 10),
            _editor: initialData?._editor || defaultEditor,
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    (0, react_1.useEffect)(() => {
        if (!dirtyFields._offer)
            return;
        setValue("_cases", undefined, { shouldValidate: true });
    }, [_offer, _offer?.id, setValue]);
    (0, react_1.useEffect)(() => {
        trigger(["creationDate", "registrationDate"]);
    }, [trigger, watch, creationDate, registrationDate]);
    (0, react_1.useEffect)(() => {
        setValue("registrationDate", creationDate);
    }, [setValue, creationDate]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_offer" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Wybierz ofert\u0119"),
            react_1.default.createElement(BussinesObjectSelectors_1.OfferSelector, { name: "_offer", readOnly: !isEditing })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Dotyczy spraw"),
            _offer ? (react_1.default.createElement(BussinesObjectSelectors_1.CaseSelectMenuElement, { name: "_cases", repository: LettersController_1.casesRepository, _offer: _offer, readonly: !_offer, onRequestCreate: () => setShowCreateCase(true), onRequestEdit: (caseItem) => {
                    setCaseToEdit(caseItem);
                    setShowEditCase(true);
                }, refreshToken: caseOptionsRefreshToken })) : (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Wybierz ofert\u0119, by przypisa\u0107 do spraw"))),
        react_1.default.createElement(InlineCreateDrawer_1.InlineCreateDrawer, { show: showCreateCase, onHide: () => setShowCreateCase(false), title: "Nowa sprawa", repository: LettersController_1.casesRepository, ModalBodyComponent: CaseInlineCreateBody_1.CaseInlineCreateBody, additionalModalBodyProps: { _offer }, makeValidationSchema: CaseInlineCreateBody_1.makeInlineCaseValidationSchema, onCreated: handleCaseCreated }),
        react_1.default.createElement(InlineCreateDrawer_1.InlineCreateDrawer, { show: showEditCase, onHide: () => setShowEditCase(false), title: "Edytuj spraw\u0119", headerBadge: (0, CaseModalButtons_1.buildCaseHeaderBadge)(caseToEdit?._parent, caseToEdit?.parentCaseId
                ? LettersController_1.casesRepository.items.find((c) => c.id === caseToEdit.parentCaseId)
                : undefined), repository: LettersController_1.casesRepository, ModalBodyComponent: CaseModalBody_1.CaseModalBody, makeValidationSchema: CaseValidationSchema_1.makeCaseValidationSchema, isEditing: true, initialData: caseToEdit, onEdited: handleCaseEdited }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "description" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Opis"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, placeholder: "Podaj opis", isValid: !errors?.description, isInvalid: !!errors?.description, ...register("description"), className: getConfidenceClass("description") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "description", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "creationDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data utworzenia"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.creationDate, isInvalid: !!errors.creationDate, ...register("creationDate"), className: getConfidenceClass("creationDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "creationDate", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, controlId: "registrationDate" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Data Nadania"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "date", isValid: !errors.registrationDate, isInvalid: !!errors.registrationDate, ...register("registrationDate") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "registrationDate", errors: errors }))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "_editor" },
            react_1.default.createElement(BussinesObjectSelectors_1.PersonSelectorPreloaded, { label: "Osoba rejestruj\u0105ca", name: "_editor", repository: MainSetupReact_1.default.personsEnviRepository })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "file" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Plik"),
            react_1.default.createElement(GenericComponents_1.FileInput, { ...register("file"), inputRef: fileInputRef }),
            isEditing && (react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted small" }, "Wcze\u015Bniej za\u0142\u0105czone pliki s\u0105 widoczne na dysku w folderze pisma. System nie zapami\u0119tuje tych plik\u00F3w jako warto\u015Bci pola wyboru pliku.")))));
}
